import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  CHeader,
  CHeaderNav,
  CHeaderNavItem,
  CHeaderNavLink,
} from '@coreui/react';

import logo from '../assets/img/bfi_logo.png';

import TheHeaderDropdown from './TheHeaderDropdown'
import DBSearchDropdown from './DBSearchDropdown';

import { logout } from "../redux/actions/userActions";

const TheHeader = (props) => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);

  const signOut = (e) => {
    dispatch(logout());
    props.history.push('/home')
  }

  return (
    <CHeader className="edge-header">
      <>
        <CHeaderNav className="d-md-down-none mr-auto">
          <CHeaderNavItem className="px-3">
            <a href="/about"><img alt="logo" style={{ width: 50, height: 50 }} src={logo} /></a>
          </CHeaderNavItem>
          <CHeaderNavItem className="px-3">
            <span style={{ color: "white", fontSize: "20px", fontWeight: "bold", fontFamily: "Roboto" }}>BFI Research Portal</span>
          </CHeaderNavItem>
        </CHeaderNav>
        <CHeaderNav className="d-md-down-none mr-right">
          <CHeaderNavItem className="px-3">
            <CHeaderNavLink style={{ color: "white" }} className="edge-header-nav-link" to="/about">About</CHeaderNavLink>
          </CHeaderNavItem>
          <CHeaderNavItem className="px-3">
            <CHeaderNavLink style={{ color: "white" }} className="edge-header-nav-link" to="/search/bfi">BFI Database Search</CHeaderNavLink>
          </CHeaderNavItem>
          <CHeaderNavItem className="px-3">
            <CHeaderNavLink style={{ color: "white" }} className="edge-header-nav-link" to="/search/mycovirus">Mycovirus Database Search</CHeaderNavLink>
          </CHeaderNavItem>
          {/* <CHeaderNavItem className="px-3">
            <DBSearchDropdown />
          </CHeaderNavItem> */}
          <CHeaderNavItem className="px-3">
            <CHeaderNavLink style={{ color: "white" }} className="edge-header-nav-link" to="/models">Endobacterial Models</CHeaderNavLink>
          </CHeaderNavItem>
          <CHeaderNavItem className="px-3">
            <CHeaderNavLink style={{ color: "white" }} className="edge-header-nav-link" to="/litsource/bfi/add">Contribute BFI</CHeaderNavLink>
          </CHeaderNavItem>
          {user.isAuthenticated ?
            <CHeaderNavItem className="px-3">
              <CHeaderNavLink style={{ color: "white" }} className="edge-header-nav-link" to="/user/projectlist">Fungal Microbiome Screen</CHeaderNavLink>
            </CHeaderNavItem>
            :
            <CHeaderNavItem className="px-3">
              <CHeaderNavLink style={{ color: "white" }} className="edge-header-nav-link" to="/public/projectlist">Fungal Microbiome Screen</CHeaderNavLink>
            </CHeaderNavItem>
          }
        </CHeaderNav>

        {user.isAuthenticated &&
          <CHeaderNav className="px-3">
            <TheHeaderDropdown user={user} logout={e => signOut(e)} />
          </CHeaderNav>
        }
      </>

    </CHeader>
  )
}

export default TheHeader
